/**
 * Created by rathompson on 6/13/22
 * File: RegionRenderer
 * Project: MSP ©Palo Alto Networks
 * © Palo Alto Networks
 */
import { useCallback } from 'react'
import { APP_ID_LOGGING_SERVICE } from '../../../../common/constants/GlobalConstants'

const RegionRenderer = ({ supportedRegionsByKey, row, value }) => {

  const getRegionDisplayName = useCallback((row, value) => {
    return (row?.original?.platform_region && (supportedRegionsByKey[APP_ID_LOGGING_SERVICE]?.find(region => region.value === value)?.description)) ||
      (row?.original?.region && (supportedRegionsByKey[row?.original?.app_id]?.find(region => region.value === value)?.description)) || value
  }, [supportedRegionsByKey])

  return <div className='cm-h-full cm-w-full cm-py-2'>{getRegionDisplayName(row, value)}</div>
}

export default RegionRenderer
